// extracted by mini-css-extract-plugin
export default {"main":"MealPlan_main__huPSd","controls":"MealPlan_controls__Ky8S3","select":"MealPlan_select__W6llI","inputChoice":"MealPlan_inputChoice__c7Dlf"};